import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard.service';
import { FormControl } from '@angular/forms';


export interface BloccoBusinessLineModel {
  idBlocco: number;
  idBusinessLine: number;
  dataInizio: string;
}

@Component({
  selector: 'app-business-line-blocco-manager',
  templateUrl: './business-line-blocco-manager.component.html',
  styleUrls: ['./business-line-blocco-manager.component.css']
})
export class BusinessLineBloccoManagerComponent implements OnInit {

  checkboxBusinessLine: Array<{
    id: number,
    name: string,
    checked: boolean
  }> = [];

  idBlocco: number;
  businessLine: FormControl = new FormControl('');

  businessLinesList: Array<{
    id: any,
    businessLine: any
  }> = [];

  constructor(
    private _dashboardService: DashboardService
  ) { }

  ngOnInit() { }

  createArrayForView(businessLines?: Array<any>) {
    this._dashboardService.getAllBusinessLines().subscribe(
      bLines => {
        this.createBusinessLineItemsArray(businessLines);

        for (const line of bLines) {
          const newRuolo = {
            id: line.id,
            name: line.codice,
            checked: this.checkForBusinessLine(line.id, businessLines ? businessLines : null)
          };
          this.checkboxBusinessLine.push(newRuolo);
        }
      }, err => { });
  }

  createBusinessLineItemsArray(businessLine) {
    if (businessLine) {
      for (let item of businessLine) {
        const itemToPush = {
          id: item.id,
          businessLine: item.idBusinessLine
        };
        this.businessLinesList.push(itemToPush);
      }
    }
  }

  checkForBusinessLine(idBusinessLine: number, businessLines?: Array<any>): boolean {
    if (businessLines) {
      return businessLines.find(item => item.idBusinessLine === idBusinessLine) ? true : false;
    } else {
      return false;
    }
  }

  setChecked(idBusinessLine: number, value: boolean) {
    const index = this.checkboxBusinessLine.findIndex(item => item.id === idBusinessLine);
    this.checkboxBusinessLine[index].checked = value;
  }

  getRuolo = () => this.businessLine.value;
  setRuolo = (ruolo: Array<string>) => this.businessLine.setValue(ruolo);

  change(option, event) {

    const bloccoToBL: BloccoBusinessLineModel = {
      dataInizio: new Date().toISOString(),
      idBusinessLine: option.id,
      idBlocco: this.idBlocco
    };

    if (event.checked) {
      this._dashboardService.addBloccoToBusinessLine(bloccoToBL).subscribe(
        res => {
          this.setChecked(bloccoToBL.idBusinessLine, true);
          this.addBusinessLine(res);
        },
        err => { });
    } else {
      const id = this.getIdBusinessLineById(bloccoToBL.idBusinessLine);
      this._dashboardService.deleteBloccoBusinessLine(id).subscribe(
        res => {
          this.setChecked(bloccoToBL.idBusinessLine, false);
          this.removeBusinessLine(res);
        },
        err => { });
    }
  }

  getIdBusinessLineById(idRuolo): number {
    const findedItem = this.businessLinesList.find(item => item.businessLine === idRuolo).id;
    return findedItem;
  }

  addBusinessLine(res) {
    this.businessLinesList = [...this.businessLinesList, { id: res.id, businessLine: res.idBusinessLine }];
  }

  removeBusinessLine(res) {
    const index = this.businessLinesList.findIndex(item => item.id === res.id);
    this.businessLinesList.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/business-line-blocco-manager/business-line-blocco-manager.component.ts